
import SlWholeSaleDiscount from '../../../models/Sale/SlWholesaleDiscount'
export default async data => {
    try {
        let newWholeSaleDiscount = new SlWholeSaleDiscount(data)
        let response = await newWholeSaleDiscount.save()
        return response
    } catch (error) {
        return error.response.data
    }
}
